var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 1.66669C5.39199 1.66669 1.66699 5.39169 1.66699 10C1.66699 14.6084 5.39199 18.3334 10.0003 18.3334C14.6087 18.3334 18.3337 14.6084 18.3337 10C18.3337 5.39169 14.6087 1.66669 10.0003 1.66669ZM13.5837 13.5834C13.2587 13.9084 12.7337 13.9084 12.4087 13.5834L10.0003 11.175L7.59199 13.5834C7.26699 13.9084 6.74199 13.9084 6.41699 13.5834C6.09199 13.2584 6.09199 12.7334 6.41699 12.4084L8.82533 10L6.41699 7.59169C6.09199 7.26669 6.09199 6.74169 6.41699 6.41669C6.74199 6.09169 7.26699 6.09169 7.59199 6.41669L10.0003 8.82502L12.4087 6.41669C12.7337 6.09169 13.2587 6.09169 13.5837 6.41669C13.9087 6.74169 13.9087 7.26669 13.5837 7.59169L11.1753 10L13.5837 12.4084C13.9003 12.725 13.9003 13.2584 13.5837 13.5834Z",
    fill: "#CC3D3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/RedCross.047ff797731f172f8cd3f79f9f0a592e.svg";
export { ForwardRef as ReactComponent };